import React from "react";
import { CmsPageBuilderEditor } from "./CmsPageBuilderEditor";
import { blogInputClass } from "./BlogEditorFormFields";

function readStoredEditorHeight() {
  const fallback = 320;
  try {
    const n = Number(sessionStorage.getItem("ainsoft-cms-blog-quill-h"));
    return Number.isFinite(n) && n >= 200 && n <= 2000 ? n : fallback;
  } catch {
    return fallback;
  }
}

/**
 * Reusable CMS page-builder / HTML editor (same as blogs).
 */
export function RichContentEditorSection({
  form,
  setForm,
  htmlMode,
  setHtmlMode,
  label = "Landing page content",
  fieldId = "rich-content",
  description = "Build a landing page with headings, text, images, columns, and buttons."
}) {
  return (
    <div className="pt-0.5">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        {htmlMode ? (
          <label className="text-xs font-medium text-slate-600" htmlFor={fieldId}>
            {label}
          </label>
        ) : (
          <span className="text-xs font-medium text-slate-600" id={`${fieldId}-label`}>
            {label}
          </span>
        )}
        <label className="flex cursor-pointer items-center gap-1.5 text-xs text-brand-800">
          <input type="checkbox" checked={htmlMode} onChange={(e) => setHtmlMode(e.target.checked)} />
          HTML source
        </label>
      </div>
      {description ? <p className="mb-2 text-xs text-slate-500">{description}</p> : null}
      {htmlMode ? (
        <textarea
          id={fieldId}
          className={`${blogInputClass} w-full font-mono`}
          style={{ minHeight: readStoredEditorHeight() }}
          value={form.content ?? ""}
          onChange={(e) => setForm((f) => ({ ...f, content: e.target.value }))}
        />
      ) : (
        <CmsPageBuilderEditor form={form} setForm={setForm} />
      )}
    </div>
  );
}
